import { render } from "./MdTable.vue?vue&type=template&id=e028b5be&scoped=true&ts=true"
import script from "./MdTable.vue?vue&type=script&lang=ts"
export * from "./MdTable.vue?vue&type=script&lang=ts"

import "./MdTable.vue?vue&type=style&index=0&id=e028b5be&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e028b5be"]])

export default __exports__